exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.site-content[data-v-4aba949e] {\n    padding: 20px;\n}\n", ""]);

// exports
